import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

/**
 * Class to retrive vehicle Types Dropdown
 */
class B2BBookingStatus extends React.Component {
  componentDidMount() {
    this.props.dispatch({
      types: [
        `GET_B2B_BOOKING_STATUS_PENDING`,
        `GET_B2B_BOOKING_STATUS_FULFILLED`,
        `GET_B2B_BOOKING_STATUS_REJECTED`,
      ],
      method: "GET",
      url: "v1/corporate-booking/booking-status",
      returnExistObject: "b2bBookingStatus",
    });
  }
 getFilteredStatuses = () => {
  const { b2bBookingStatus: { response: b2bBookingStatus }, allowedStatuses } = this.props;
  
  if (!b2bBookingStatus || !b2bBookingStatus.length) {
    return [];
  }
  
  // If allowedStatuses prop is provided, filter by it
  if (allowedStatuses && allowedStatuses.length) {
    return b2bBookingStatus.filter(status => 
      allowedStatuses.includes(status.status)
    );
  }
  
  // Otherwise return all statuses
  return b2bBookingStatus;
};

  render() {
    const {
      b2bBookingStatus: { response: b2bBookingStatus },
      dispatch,
      ...rest
    } = this.props;


   
    const filteredStatuses = this.getFilteredStatuses();

return (
  <select {...rest}>
    <option value=""> -- Select -- </option>
    {filteredStatuses.map((type, index) => (
      <option value={type.id} key={index}>
        {type.status}
      </option>
    ))}
  </select>
);
  }
}
B2BBookingStatus.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  allowedStatuses: PropTypes.array,
};
export default connect((state) => {
  return {
    b2bBookingStatus: state.b2bBookingStatus,
  };
})(B2BBookingStatus);
